<template>
  <div class="integral b_white">
    <van-list
      :loading="loading"
      :finished="finished"
      :offset="20"
      :immediate-check="false"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <ul>
        <li class="flex justify_between align_center" v-for="record in allRecordList" :key="record.shopId">
          <img :src="record.shopPicUrl + '?imageView2/0/w/40/h/40'" alt="">
          <div class="flex_1 gray_3">
            <div class="flex align_center">
              <span class="f15_rem">{{record.points}}</span>
              <span class="f10_rem int-detail flex justify_center align_center" @click="toRecordDetail(record)">明细</span>
            </div>
            <div class="f12_rem">{{record.shopName}}</div>
          </div>
          <div class="f10_rem white b_red int-used flex justify_center align_center" @click="toShopDetail(record.shopId)">去使用</div>
        </li>
      </ul>
    </van-list>
  </div>
</template>
<script>

// import { Toast } from 'vant';
import { mapState } from "vuex";
import { Toast } from "vant";
import common from "@/assets/js/common";
// import common from '@/assets/js/common';

export default {
  data() {
    return {
      shopId: "",
      finished: false,
      loading: false,
      allRecordList: [],
      pageNum: 1,
      pageSize: 12
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    this.shopId = this.$route.params.shopId;
    if (!common.isLogin(this.userInfo.id)) {
      return;
    }
    this.getMyPointsList(true);
  },
  methods: {
    getMyPoints(load) {
      if (load === true) {
        Toast.loading({
          mask: true,
          message: "加载中...",
          duration: 0
        });
      }
      const params = {
        shopId: this.shopId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$store.dispatch("shop/shopPoints/getMyPointsRecord", params).then((data) => {
        Toast.clear();
        const newData = data || {};
        const list = newData.list || [];
        // 加载状态结束
        this.loading = false;
        // 加载更多
        this.allRecordList = [...this.allRecordList, ...list];
        if (list.length === 0) {
          this.finished = true;
        }
      }).catch(() => {
        Toast.clear();
      });
    },
    onLoad() {
      this.loading = true;
      this.clickToMore();
    },
    // 加载更多
    clickToMore() {
      this.pageNum = this.pageNum + 1;
      this.getMyPointsList(false);
    },
    getMyPointsList(load) {
      if (load === true) {
        Toast.loading({
          mask: true,
          message: "加载中...",
          duration: 0
        });
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$store.dispatch("shop/shopPoints/getMyPointsList", params).then((data) => {
        Toast.clear();
        const newData = data || {};
        const list = newData.list || [];
        // 加载状态结束
        this.loading = false;
        // 加载更多
        this.allRecordList = [...this.allRecordList, ...list];
        if (list.length === 0) {
          this.finished = true;
        }
      }).catch(() => {
        Toast.clear();
      });
    },
    toShopDetail(id) {
      window.location.href = `${process.env.VUE_APP_APP}mob/shop/shopDetail/${id}`;
    },
    toRecordDetail(record) {
      this.$router.push({
        path: "/integral/detail",
        query: {
          shopId: record.shopId
        }
      });
    }
  }
};
</script>


<style lang="scss" scoped>
  @import './style.scss';
</style>
